import React from 'react';

import {
  required,
  TextInput,
  SelectInput,
  AutocompleteInput,
} from 'react-admin';

import { Grid } from '@mui/material';

import requestEntityFields from '../../../../constants/requestEntityFields';
import requestTypes from '../../../../constants/requestTypes';
import currencies from '../../../../constants/currencies';
import { transmodeTypesChoices } from '../../../../constants/transmodeTypes';
import SmartDateInput from '../../../../customFields/SmartDateInput';
import ReferenceEntityInputV2 from '../../../../customFields/ReferenceEntityInputV2';
import requestRolesChoices from '../../../../constants/requestRoles';

const Transaction = () => (
  <Grid container>
    <Grid size={12} container columnSpacing={6}>
      <TextInput source="extraInformation.amount" label="Amount" validate={required()} />
      <SmartDateInput source="extraInformation.date" label="Date" validate={required()} />
      <AutocompleteInput label="Currency" source="extraInformation.currency" choices={currencies.map((currency) => ({ id: currency, name: currency }))} validate={required()} />
      <TextInput source="extraInformation.textMessage" label="Text message" />
      <TextInput source="extraInformation.reference" label="Reference" />
      <SelectInput choices={transmodeTypesChoices} source="extraInformation.transactionChannel" label="Transaction channel" />
      <TextInput source="extraInformation.transactionChannelProvider" label="Transaction channel provider" />
      <TextInput source="extraInformation.initiator.payerName" label="Payer name" />
      <TextInput source="extraInformation.recipient.beneficiaryName" label="Beneficiary name" />
    </Grid>
    <Grid
      display="flex"
      size={12}
      container
      columnSpacing={6}
    >
      {requestEntityFields[requestTypes.TRANSACTION.id].map((role) => (
        <ReferenceEntityInputV2
          key={role}
          label={requestRolesChoices[role].name}
          source={`extraInformation.${role}`}
        />
      ))}
    </Grid>
  </Grid>
);

export default Transaction;
